import React, { useState, useContext } from 'react';
import { AiFillInstagram, AiFillPinterest, AiFillYoutube ,AiFillFacebook} from 'react-icons/ai';
import '../ProductList.css';
import { CartContext } from "../CartContext";
import { db } from "../firebase";
import { collection, addDoc } from "firebase/firestore";
import CustomerReviewsDisplay from "./CustomerReviewsDisplay"

const Footer = () => {
    const { setEmail } = useContext(CartContext);
    const inputRef = React.useRef(null);
    
    // const subs = async (e) => {
    //     const emailValue = inputRef.current.value;
    //     e.preventDefault();
        
    //     // Check if the email is valid
    //     if (!emailValue) return alert("Please enter a valid email!");
        
    //     try {
    //         // Add email to Firestore collection
    //         await addDoc(collection(db, "subscribers"), { email: emailValue });
            
    //         setEmail(emailValue);  // Set email value in context
    //         inputRef.current.value = "";  // Clear the input field
            
    //         alert("🔔 Thank you for subscribing 📩");
    //     } catch (error) {
    //         console.error("Error saving email: ", error);
    //     }
    // };
const subs = async (e) => {
    e.preventDefault();
    
    let emailValue = inputRef.current.value.trim(); // Trim whitespace

    // Basic email pattern for validation
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

    if (!emailValue || !emailRegex.test(emailValue)) {
        return alert("Please enter a valid email!");
    }

    // Additional sanitation: escape HTML characters (XSS protection)
    emailValue = emailValue.replace(/[&<>"'`=\/]/g, function (char) {
        return ({
            '&': '&amp;',
            '<': '&lt;',
            '>': '&gt;',
            '"': '&quot;',
            "'": '&#39;',
            '/': '&#x2F;',
            '`': '&#x60;',
            '=': '&#x3D;'
        })[char];
    });

    
    try {
        await addDoc(collection(db, "subscribers"), { email: emailValue });
        setEmail(emailValue);
        inputRef.current.value = "";
        alert("🔔 Thank you for subscribing 📩");
    } catch (error) {
        console.error("Error saving email: ", error);
    }
};

    return (
        <>
            <div style={{ display: "flex", justifyContent: "center", marginLeft: "auto", marginRight: "auto", marginTop: 5 }}>
                <img id="ll" src="https://res.cloudinary.com/dcuturlmb/image/upload/v1759925382/my_uploads/d01vd3nwnpr38vlqbvfp.png" style={{ width: "100%", height: 100, maxWidth: 800 }} />
            </div>
            <div className="footer" style={{ margin: "auto", display: "flex", marginTop: -25 }}>
                <p style={{ fontSize: "0.9rem", marginLeft: "auto", marginRight: "auto", color: "#071d49" }}>&copy; 2024, All Rights Reserved</p>
            </div>

            <div className="footer" style={{ margin: "auto", display: "flex", marginTop: -10 }}>
            <p style={{ fontSize: "0.9rem", marginLeft: "auto", marginRight: "auto", color: "#071d49" }}>
                <a style={{textDecoration:"none", color: "#071d49"}} href="/refund-policy" target="_blank">Return & Refund Policy</a>
            </p>
           </div>
           <div className="footer" style={{ margin: "auto", display: "flex", marginTop: -10 }}>
            <p style={{ fontSize: "0.9rem", marginLeft: "auto", marginRight: "auto", color: "#071d49" }}>
                <a style={{textDecoration:"none", color: "#071d49"}} href="/our-policy" target="_blank">Privacy Policy</a>
            </p>
           </div>
                                  <div className="footer" style={{ margin: "auto", display: "flex", marginTop: -10 }}>
            <p style={{ fontSize: "0.9rem", marginLeft: "auto", marginRight: "auto", color: "#071d49" }}>
                <a style={{textDecoration:"none", color: "#071d49"}} href="/Contact-us" target="_blank">Contact Us</a>
            </p>
           </div>
            <div style={{ display: "flex", justifyContent: "center", marginLeft: "auto", marginRight: "auto", marginTop: -20 }}>
                <p style={{ fontSize: 30 }}>
                    <a style={{ color: "#071d49" }} href="https://www.instagram.com/wearandwonderboutique/" target="_blank"><AiFillInstagram /></a>
                </p>
                <p style={{ fontSize: 30}}>
                     <a style={{ color: "#071d49" }} href="https://www.pinterest.com/pin/883268545682464635/" target="_blank"> <AiFillPinterest /></a>
                </p>
                <p style={{ fontSize: 30}}>
                    <a style={{ color: "#071d49" }} href="https://www.youtube.com/channel/UCiHDIu6aYNtHn4Fcv5TcvLg" target="_blank"><AiFillYoutube /></a>
                </p>
                <p style={{ fontSize: 30}}>
                    <a style={{ color: "#071d49" }} href="https://www.facebook.com/profile.php?id=61583350015395" target="_blank"><AiFillFacebook /></a>
                </p>
            </div>

            <div className="email" style={{
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                flexDirection: "column",
                width: "100%",
                boxSizing: "border-box",
                marginTop: -10
            }}>
                {/* <input
                    ref={inputRef}
                    style={{
                        textAlign: "center",
                        fontSize: "12px",
                        width: "100%",
                        maxWidth: "200px",
                        height: "28px",
                        padding: "5px",
                        marginBottom: "-5px",
                        borderRadius: "15px",
                        border: "2px solid #071d49",
                        color: "#A60065",
                              backgroundColor: "white"
                        // backgroundColor: "#f5efe3"
                    }}
                    type="email"
                    placeholder="Enter your email to get notified on our sales"
                /> */}
                <a href="/signup"
                                    style={{
                        backgroundImage: "linear-gradient(to right, #071d49, #A60065)",
                        color: "#f5efe3",
                        borderRadius: 15,
                        fontWeight: "bold",
                        marginBottom: 10,
                        height: 30,
                        width: "100%",
                        maxWidth: 170,
                        marginTop: 1
                    }}>
                <button
                    // onClick={subs}
                    style={{
                        backgroundImage: "linear-gradient(to right, #071d49, #A60065)",
                        color: "#f5efe3",
                        borderRadius: 15,
                        fontWeight: "bold",
                        marginBottom: 10,
                        height: 30,
                        width: "100%",
                        maxWidth: 170,
                        marginTop: 1
                    }}
                >
                    SUBSCRIBE
                </button>
                </a>
                          <div style={{
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                flexDirection: "column",
                width: "100%",
                boxSizing: "border-box",
               
            }}>
{/* <a href=""> */}
 <CustomerReviewsDisplay/>
    {/* </a> */}
                    </div>
               
            </div>
        </>
    );
};

export default Footer;
